// extracted by mini-css-extract-plugin
module.exports = {"queryOutput":"Output_queryOutput__1B1iO","inPrint":"Output_inPrint__28D44"};